import { gql } from './__generated__';

export const GET_QUESTION_SOURCE_RELATION_TYPE = gql(/* GraphQL */ `
  query getQuestionSourceRelationTypes {
    questionSourceRelationType {
      getAll {
        id
        name
        type
      }
    }
  }
`);
